export enum Namenszusatz {
  BAR = 'Bar',
  BARON = 'Baron',
  BARONESS = 'Baroness',
  BARONESSE = 'Baronesse',
  BARONIN = 'Baronin',
  BRAND = 'Brand',
  BURGGRAF = 'Burggraf',
  BURGGRÄFIN = 'Burggräfin',
  CONDESA = 'Condesa',
  EARL = 'Earl',
  EDLE = 'Edle',
  EDLER = 'Edler',
  ERBGRAF = 'Erbgraf',
  ERBGRÄFIN = 'Erbgräfin',
  ERBPRINZ = 'Erbprinz',
  ERBPRINZESSIN = 'Erbprinzessin',
  FFR = 'Ffr',
  FREIFR = 'Freifr',
  FREIFRÄULEIN = 'Freifräulein',
  FREIFRAU = 'Freifrau',
  FREIH = 'Freih',
  FREIHERR = 'Freiherr',
  FREIIN = 'Freiin',
  FRF = 'Frf',
  FRF_DOT = 'Frf.',
  FRFR = 'Frfr',
  FRFR_DOT = 'Frfr.',
  FRH = 'Frh',
  FRH_DOT = 'Frh.',
  FRHR = 'Frhr',
  FRHR_DOT = 'Frhr.',
  FST = 'Fst',
  FST_DOT = 'Fst.',
  FSTN = 'Fstn',
  FSTN_DOT = 'Fstn.',
  FÜRST = 'Fürst',
  FÜRSTIN = 'Fürstin',
  GR = 'Gr',
  GRAF = 'Graf',
  GRÄFIN = 'Gräfin',
  GRF = 'Grf',
  GRFN = 'Grfn',
  GROSSHERZOG = 'Grossherzog',
  GROßHERZOG = 'Großherzog',
  GROSSHERZOGIN = 'Grossherzogin',
  GROßHERZOGIN = 'Großherzogin',
  HERZOG = 'Herzog',
  HERZOGIN = 'Herzogin',
  JHR = 'Jhr',
  JHR_DOT = 'Jhr.',
  JONKHEER = 'Jonkheer',
  JUNKER = 'Junker',
  LANDGRAF = 'Landgraf',
  LANDGRÄFIN = 'Landgräfin',
  MARKGRAF = 'Markgraf',
  MARKGRÄFIN = 'Markgräfin',
  MARQUES = 'Marques',
  MARQUIS = 'Marquis',
  MARSCHALL = 'Marschall',
  OSTOJA = 'Ostoja',
  PRINZ = 'Prinz',
  PRINZESSIN = 'Prinzessin',
  PRZIN = 'Przin',
  RABE = 'Rabe',
  REICHSGRAF = 'Reichsgraf',
  REICHSGRÄFIN = 'Reichsgräfin',
  RITTER = 'Ritter',
  RR = 'Rr',
  TRUCHSESS = 'Truchsess',
  TRUCHSEß = 'Truchseß',
}
